export class AccountEnumsModel {
  constructor() {}
  public listAccountNature: [];
  public listAccountSource: [];
  public listAccountType: [];
  public listCurrency: [];
}
